import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinkhutbavpune() {



const cardData =
  {
    keyword: 'Bus On Rent in Khutbav Pune',
    heading: 'Sanavi Travels: Bus On Rent in Khutbav Pune',
    headingDescription: 'Sanavi Travels provides reliable, comfortable, and professionally managed Bus On Rent in Khutbav Pune, catering to the growing group travel needs of families, villagers, corporate teams, schools, wedding guests, picnic groups, and outstation travelers. Khutbav, located in Pune district near Daund taluka, is surrounded by agricultural villages, residential pockets, educational institutions, and social venues, resulting in frequent demand for organized group transportation. To meet these requirements, we offer a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for both short local journeys and long-distance travel. Each bus is well-maintained with comfortable seating, smooth suspension, proper ventilation, and ample luggage space to ensure a pleasant journey for passengers of all age groups. ',

    top: 'Top Places to Visit Near Khutbav Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Khutbav Village",
    "description": "Khutbav is a well-connected village in Pune district known for its agricultural activities, close-knit community life, and frequent social gatherings. The village regularly hosts weddings, religious ceremonies, and cultural events that require organized transportation for large groups. Bus rentals play a vital role in ensuring everyone travels together comfortably, arrives on time, and avoids coordination challenges associated with multiple vehicles. Hiring a bus from Khutbav simplifies group movement while offering cost-effective and reliable travel solutions."
  },
  {
    "title": "Daund Town",
    "description": "Daund is a major railway junction and commercial hub located close to Khutbav, attracting daily visitors for business, education, healthcare, and official work. Residents of Khutbav frequently travel to Daund for markets, offices, and social visits. Bus hire services provide an efficient and economical way for groups to travel together, especially during busy market days and festival seasons when traffic and parking can become challenging."
  },
  {
    "title": "Agricultural Belt Around Khutbav",
    "description": "The areas surrounding Khutbav are rich in agricultural land producing sugarcane, grains, and seasonal crops. These rural regions witness regular travel for farming activities, family functions, and community programs. Bus rentals are ideal for safely transporting groups across rural roads while maintaining comfort, schedule discipline, and cost efficiency."
  },
  {
    "title": "Local Temples and Religious Sites",
    "description": "Several temples and spiritual centers near Khutbav attract devotees throughout the year, particularly during festivals and religious occasions. Group travel by bus makes temple visits convenient and organized, allowing families and devotees to travel together comfortably without worrying about logistics or parking."
  },
  {
    "title": "Weekly Markets and Bazaars",
    "description": "Weekly rural markets near Khutbav serve as important centers for trade and social interaction, drawing visitors from nearby villages. Bus hire services are often used by trader groups, farmers, and community members for collective travel, offering convenience and affordability."
  },
  {
    "title": "Wedding Lawns and Event Venues",
    "description": "Marriage halls, open lawns, and event venues around Khutbav and Daund rely heavily on bus rentals for guest transportation. Buses help manage large crowds efficiently, reduce parking congestion, and ensure guests reach venues comfortably and on time."
  },
  {
    "title": "Educational Institutions Nearby",
    "description": "Schools and colleges in the surrounding region frequently organize educational tours, sports competitions, and cultural events. Bus hire services provide safe, supervised, and punctual transportation for students and staff, making group travel well-organized and secure."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open countryside areas, small water bodies, and leisure spots near Khutbav are popular destinations for school picnics, family outings, and office get-togethers. Hiring a bus allows groups to enjoy the journey together and return safely without the stress of managing multiple vehicles."
  },
  {
    "title": "Industrial and Commercial Areas",
    "description": "Small industrial units and commercial establishments around Daund generate regular demand for employee transport and visitor travel from Khutbav. Bus hire services support organized corporate travel and staff transportation needs efficiently and reliably."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Khutbav is well connected to Pune city, Solapur, Ahmednagar, Shirdi, and other nearby destinations. Bus rentals are ideal for outstation group travel, offering comfort, safety, and economical transportation for tours, pilgrimages, and extended family trips."
  }
]
,



"services": [
{
"name": "Bus On Rent in Khutbav Pune",
"description": "Bus On Rent in Khutbav Pune provides reliable and comfortable buses for families, schools, corporate teams, and social events. This service is ideal for weddings, picnics, school trips, religious journeys, and outstation travel. Our buses are spacious, clean, and well-maintained with comfortable seating, proper ventilation, smooth suspension, and ample luggage space. Professional drivers ensure disciplined driving, punctual pickups, and safe journeys, making group travel organized and stress-free."
},
{
"name": "Bus Hire Khutbav Pune",
"description": "Bus Hire Khutbav Pune offers flexible rental options for both short-distance and long-distance travel. Whether it is a village function, family gathering, or extended tour, this service ensures dependable transportation with suitable bus options for different group sizes."
},
{
"name": "AC Bus Rental Khutbav",
"description": "AC Bus Rental Khutbav is ideal for travelers seeking enhanced comfort during summer months and long journeys. Fully air-conditioned interiors, cushioned seating, and reduced travel fatigue make AC buses perfect for weddings, corporate travel, and extended tours."
},
{
"name": "Non AC Bus on Rent Khutbav",
"description": "Non AC Bus on Rent Khutbav provides economical and reliable transportation for short routes, rural travel, school trips, and budget-friendly group journeys without compromising safety."
},
{
"name": "Luxury Bus on Rent Khutbav Pune",
"description": "Luxury Bus on Rent Khutbav Pune delivers premium travel experiences with modern interiors, stylish seating, and superior comfort. Ideal for weddings, VIP guests, and special events, luxury buses ensure an elegant and memorable journey."
},
{
"name": "Mini Bus Hire Khutbav",
"description": "Mini Bus Hire Khutbav is suitable for small to medium-sized groups such as family outings, office teams, and local events, offering comfort, flexibility, and economical pricing."
},
{
"name": "32 Seater Bus on Rent Khutbav",
"description": "32 Seater Bus on Rent Khutbav is ideal for medium-sized groups including school excursions, corporate outings, and community programs, offering balanced capacity and comfortable travel."
},
{
"name": "35 Seater Bus Hire Khutbav",
"description": "35 Seater Bus Hire Khutbav supports larger group travel needs such as weddings, religious tours, and long-distance journeys with organized seating and professional drivers."
},
{
"name": "Bus on Rent Khutbav for Wedding",
"description": "Bus on Rent Khutbav for Wedding ensures timely and coordinated transportation for wedding guests and family members, simplifying event logistics and reducing travel stress."
},
{
"name": "Bus on Rent Khutbav for Corporate",
"description": "Bus on Rent Khutbav for Corporate supports employee movement, meetings, conferences, and team outings with a strong focus on punctuality and professionalism."
},
{
"name": "Bus on Rent Khutbav for Picnic",
"description": "Bus on Rent Khutbav for Picnic provides safe and enjoyable transportation for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Khutbav Outstation",
"description": "Bus Rental Khutbav Outstation offers dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Khutbav with Driver",
"description": "Bus Hire Khutbav with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Affordable Bus Rental Khutbav Pune",
"description": "Affordable Bus Rental Khutbav Pune delivers budget-friendly bus hire solutions without compromising on cleanliness, safety, or service reliability."
},
{
"name": "Best Bus Service Khutbav",
"description": "Best Bus Service Khutbav is known for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a trusted choice."
}
],
"tableData": [
["Bus On Rent in Khutbav Pune", "Bus Hire Khutbav Pune"],
["AC Bus Rental Khutbav", "Non AC Bus Hire Khutbav"],
["Luxury Bus Khutbav", "Mini Bus Hire Khutbav"],
["32 Seater Bus Khutbav", "35 Seater Bus Khutbav"],
["Wedding Bus Khutbav", "Corporate Bus Khutbav"],
["Picnic Bus Khutbav", "Outstation Bus Khutbav"],
["Bus Hire Khutbav with Driver", "Affordable Bus Rental Khutbav"],
["Best Bus Service Khutbav", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Khutbav Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus rental services in Khutbav Pune for families, schools, and corporate groups."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "Our buses are regularly maintained to ensure comfort, cleanliness, and a smooth travel experience."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Drivers are familiar with Khutbav, Daund, Pune, and nearby routes, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "We follow honest pricing policies with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose hourly, full-day, multi-day, or customized rental plans as per travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and disciplined operations for stress-free group travel."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Khutbav Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Khutbav Pune for all types of group travel.'
  },
  {
    question: 'What types of buses are available in Khutbav?',
    answer: 'We provide AC buses, Non AC buses, mini buses, luxury buses, and 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus rental available for weddings and picnics?',
    answer: 'Yes, we provide dedicated bus services for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Khutbav?',
    answer: 'Yes, outstation bus rentals are available from Khutbav to multiple destinations.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before each trip.'
  },
  {
    question: 'Is customer support available during travel?',
    answer: 'Yes, our 24/7 customer support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Kharade',
    feedback: 'We hired a bus from Khutbav for a wedding near Daund. The service was smooth and very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Pawar',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Khutbav. Clean bus and professional driver.',
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Khutbav Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Khutbav Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Khutbav Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Khutbav Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/222.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinkhutbavpune;